import FlowComponent from "../components/reactflow/FlowComponent";
import DashboardMenu from "../components/DashboardMenu";

import { useGraphContext } from "../contexts/GraphProvider";

import "./Dashboard.scss";

const Dashboard = () => {
  const { graph } = useGraphContext();

  return (
    <div className="dashboard-root">
      <DashboardMenu />
      <FlowComponent graph={graph} />
    </div>
  );
};
export default Dashboard;
